import React, { useState, useEffect, useRef } from "react";
import {
  Avatar,
  Button,
  Input,
  Form,
  Select,
  Row,
  Col,
  Spin,
  Tooltip,
  Divider,
  Space,
  message,
  Popconfirm
} from "antd";
import {
  PlusOutlined,
  DeleteOutlined,
  QuestionCircleOutlined,
  DownloadOutlined
} from "@ant-design/icons";
import UserIcon from "../../../../assets/images/icons/userLogo.svg";
import { useParams, useLocation } from "react-router-dom";
import { useStore } from "../../../../store";
import { TAB_KEYS } from "../../../../config";
import { useTab } from "../../../../custom-hooks/useTab";
import { useConnectsuForm } from "../../../../custom-hooks/useConnectsuForm";
import { getFormFieldValue } from "../../../../utils";
import ReactPlayer from "react-player/youtube";
import products from "../../../organisations/json/products.json";
import { deleteRequest, getRequest, putRequest } from "../../../../api/http";
import userServiceApi from "../../../../api/userServiceApi";
import { toast } from "react-toastify";
import { truncateFilename, sortDataByOrder } from "../../../../utils/helper"
import SynthesiaVideo from "./SynthesiaVideo";
import reArrangeOrder from "../../../common/DragAndDropList/rearrangeHelper";
import {
  DragAndDropList,
  GifCreator,
  GifResultPreview,
  createEmptyGifState,
  hydrateGifCreatorState,
} from "../../../common";
import "./WhyWorkForUs.scss";

const { TextArea } = Input;
const MAX_CHARACTERS = 1000;

const withGifDefaults = (rows) => {
  if (!Array.isArray(rows)) return rows;
  return rows.map((row) => {
    if (row?.mediaLink?.mediaType === "GIF") {
      return {
        ...row,
        mediaLink: {
          ...row.mediaLink,
          gifCreator: hydrateGifCreatorState(row.mediaLink),
        },
      };
    }
    return row;
  });
};

export default function ProductComponent({ dataLoader, form, getSingleTabData, loader: formDataLoader }) {
  const { micrositeId } = useParams();
  const { state } = useLocation();
  const inputRef = useRef(null);

  const tabKey = state;
  const { tabData } = useStore();
  const whichTab = TAB_KEYS.product;
  const { deleteSingleItem, postLoader } = useTab();
  const { updateImage, updateFile } = useConnectsuForm();
  const [loader, setLoader] = useState(formDataLoader || true);
  const [formChanged, setFormChanged] = useState(false);
  const { updatedValues } = useStore();
  const [newProductGroup, setNewProductGroup] = useState("");
  const tabConfigId = localStorage?.getItem("selectedTabId");
  
 const [items] = useState(products.map((item) => item.name));

 const [, setShowClear] = useState(false);
 const [, setClearEnabled] = useState(false);
  const [canAddNew, setCanAddNew] = useState(true);
  const [hasUnsavedItem, setHasUnsavedItem] = useState(false);
  const [productsGroupList, setProductsGroupList] = useState([]);

  const getProductsGroup = async () => {
    try {
      const res = await getRequest(
        userServiceApi.getSectionTitles(micrositeId, tabConfigId)
      );
      if (res?.data) {
        const filteredData = res?.data.filter(
          (item) => item.title != null && item.title.trim() !== ""
        );
        setProductsGroupList(filteredData);
      }
    } catch (error) {
      toast.error(error.error);
    }
  };

  useEffect(() => {
    if (micrositeId && tabConfigId) {
      getProductsGroup();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [micrositeId, tabConfigId]);

  useEffect(() => {
    if (tabData[whichTab]) {
      tabData[whichTab].forEach((item) => {
        if (item?.title && !items.includes(item.title)) {
          items.push(item.title);
        }
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabData[whichTab]]);

  useEffect(() => {
    localStorage.setItem("tab", "PRODUCT");
  }, []);

  useEffect(() => {
    const isNotEmpty = Object.keys(updatedValues).length > 0;

    setFormChanged(isNotEmpty);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Object.keys(updatedValues).length]);

  const renderMedia = (dataItem, rowIndex) => {
    const commonStyles = {
      display: "flex",
      justifyContent: "center",
    };

    if (
      dataItem?.mediaLink?.mediaType === "SOCIAL_MEDIA" &&
      dataItem.mediaLink.url
    ) {
      return (
        <div className={`iframe-comp ${dataItem?.mediaLink?.mediaType}`} style={commonStyles}>
          <ReactPlayer
            controls={true}
            url={dataItem.mediaLink.url}
            width="100%"
            height="100%"
          />
        </div>
      );
    } else if (
      dataItem?.mediaLink?.mediaType === "VIMEO_MEDIA" &&
      dataItem.mediaLink.url
    ) {
      return (
        <div className={`iframe-comp ${dataItem?.mediaLink?.mediaType}`} style={commonStyles}>
          <iframe
            title="Embedded video"
            src={dataItem.mediaLink.url}
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
            width="100%"
            height="100%"
            style={{ backgroundColor: "black" }}
          />
        </div>
      );
    } else if (
      dataItem?.mediaLink?.mediaType === "IMAGE" &&
      dataItem.mediaLink.url
    ) {
      return (
        <div className={`iframe-comp ${dataItem?.mediaLink?.mediaType}`} style={commonStyles}>
          <img
            src={dataItem?.mediaLink?.url}
            alt=""
            className="c1 carousel-image"
            style={{ maxWidth: "100%", maxHeight: "100%" }}
          />
        </div>
      );
    } else if (
      dataItem?.mediaLink?.mediaType === "GIF"
    ) {
      const gifState = dataItem.mediaLink.gifCreator || {};
      const gifUrl = gifState.previewUrl || dataItem.mediaLink.url;
      return (
        <GifResultPreview
          url={gifUrl}
          fileName={gifState.fileName}
          loading={!!gifState.generating}
          showEdit={!!gifUrl && gifState.isEditing === false}
          onEdit={() => {
            const current = form.getFieldValue([
              whichTab,
              rowIndex,
              "mediaLink",
              "gifCreator",
            ]);
            form.setFieldValue(
              [whichTab, rowIndex, "mediaLink", "gifCreator"],
              { ...createEmptyGifState(), ...current, isEditing: true }
            );
          }}
        />
      );
    }

    else if (
      dataItem?.mediaLink?.mediaType === "SYNTHESIA_MEDIA" &&
      dataItem.mediaLink.url) {
      return (
        <div className={`iframe-comp ${dataItem?.mediaLink?.mediaType}`} style={commonStyles}>
          <SynthesiaVideo key={dataItem.id} videoData={dataItem} />

        </div>
      )
    }

    return null;
  };

  const findValue = (i, key) => {
    return getFormFieldValue(form, whichTab, i, key);
  };

  const handleDeleteBrochure = async (id) => {
    try {
      const res = await deleteRequest(userServiceApi.deleteBrochure(id))
      if (res) {
        toast.success('Successfully Delete Brochure')
        getSingleTabData(tabKey, form)
      }
    } catch (error) {
      toast.error('Failed to Delete Brochure')
    }
  }

  const handleAddMore = () => {
    if (!canAddNew) {
      message.warning("You must save the current item before you can add a new one.");
      return;
    }

    const currentList = form.getFieldValue(whichTab) || [];

    // ✅ Prepend a fresh row
    const newList = [
      {
        assetTitleId: undefined,
        subTitle: "",
        description: "",
        mediaLink: { mediaType: undefined, url: "", gifCreator: undefined },
        urlLink: "",
        BrochureFile: null,
        brochureFileName: "",
        brochureFilePath: "",
        media: null,
      },
      ...currentList,
    ];

    form.setFieldsValue({ [whichTab]: newList });

    setCanAddNew(false);
    setHasUnsavedItem(true);;
    // Scroll to top for visibility
    window.scrollTo({ top: 0, behavior: "smooth" });
  };


  const handleClear = () => {
    const currentList = form.getFieldValue(whichTab) || [];

    // Reset unsaved rows
    const updatedList = currentList.map(item =>
      !item?.id
        ? {
          assetTitleId: undefined,
          subTitle: "",
          description: "",
          mediaLink: { mediaType: undefined, url: "", gifCreator: undefined },
          urlLink: "",
          BrochureFile: null,
          brochureFileName: "",
          brochureFilePath: "",
          media: null,
        }
        : item
    );

    form.setFieldsValue({ [whichTab]: updatedList });
    setShowClear(false);
    setClearEnabled(false);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      if (tabData?.product?.length === 0) {
        setHasUnsavedItem(true);
      } else {
        setHasUnsavedItem(false);
      }
    }, 500);

    return () => clearTimeout(timer); // cleanup for safety
  }, [tabData?.product]);

  const refreshUnsavedState = () => {
    const currentList = form.getFieldValue(whichTab) || [];
    const unsavedItem = currentList.find(item => {
      const hasData =
        item?.subTitle?.trim() ||
        item?.description?.trim() ||
        item?.mediaLink?.url?.trim() ||
        item?.media ||
        item?.BrochureFile ||
        item?.mediaLink?.gifCreator?.images?.length ||
        item?.mediaLink?.gifCreator?.generatedFile;

      return !item?.id && hasData;
    });

    setCanAddNew(!unsavedItem);
    setHasUnsavedItem(!!unsavedItem);
  };

  const onProductGroupChange = (event) => {
    setNewProductGroup(event.target.value);
  };

  const addProductsGroup  = async(title) => {
    try {
      await putRequest(
        userServiceApi.addSectionTitle(micrositeId, tabConfigId),
        [{ title }]
      );
      setNewProductGroup("");
      toast.success("Product added successfully");
      getProductsGroup();
    } catch (error) {
      toast.error(error.error);
    }
  } 

  const deleteProductsGroup = async (titleId) => {
    try {
      const res = await deleteRequest(userServiceApi.deleteSectionTitle(titleId));
      if (res) {
        toast.success("Product deleted successfully");
        getProductsGroup();
      }
      
    } catch (error) {
      toast.error(error.error);
    }
  };

  useEffect(() => {
    form.resetFields();
    if (tabData && tabData[whichTab] && tabData[whichTab].length > 0) {
      form.setFieldsValue({
        [whichTab]: withGifDefaults(sortDataByOrder(tabData[whichTab])),
      });
    }
    refreshUnsavedState();
    setTimeout(() => {
      setLoader(false);
    }, 1000);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabData[whichTab]]);


  useEffect(() => {
    const unsubscribe = form.subscribe?.(() => {
      refreshUnsavedState();
    });

    return () => {
      if (unsubscribe) unsubscribe();
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form]);


  if (dataLoader || postLoader || loader) {
    return (
      <div className="data-loader">
        <Spin tip="Loading" size="large" />
      </div>
    );
  } else {

    return (
      <div className="newContantStyle">
        <Row className="rowBody" gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          {tabKey === whichTab ? (
            <>
              <Col className="gutter-row tabContent" span={24}>
                <>

                  <Form.List
                    name={whichTab}
                    initialValue={
                      tabData && tabData[whichTab] && tabData[whichTab].length > 0
                        ? withGifDefaults(sortDataByOrder(tabData[whichTab]))
                        : [""]
                    }
                  >
                    {(fields, { add, remove, move }) => {
                      return (
                        <>
                          <Col
                            className="gutter-row tabContent"
                            xs={24}
                            sm={24}
                            md={14}
                            lg={14}
                            style={{ paddingRight: "25px" }}
                          >
                            <div className="inputBody">
                              <label></label>
                              <div style={{ textAlign: "right" }}>
                                {hasUnsavedItem && (
                                  <Button
                                    className="cancelBtn"
                                    type="button"
                                    onClick={handleClear}
                                  >
                                    Clear
                                  </Button>
                                )}

                                <Button
                                  className="greenBtn"
                                  onClick={handleAddMore}
                                >
                                  Add <PlusOutlined />
                                </Button>
                              </div>
                            </div>
                          </Col>

                          <Col
                            className="gutter-row tabContent"
                            xs={24}
                            sm={24}
                            md={10}
                            lg={10}
                          >
                          </Col>

                          <DragAndDropList
                            fields={fields}
                            move={move}
                            form={form}
                            fieldName={whichTab}
                            onReorder={(payload) => reArrangeOrder(userServiceApi.reArrangeCardsData({ micrositeId, tabConfigId }), payload)}
                            renderItem={({ key, name, ...restField }, i) => {
                            return (
                              <div className="card-item">
                                <Col
                                  className="gutter-row tabContent"
                                  xs={24}
                                  sm={24}
                                  md={14}
                                  lg={14}
                                  style={{ paddingRight: "25px" }}
                                >
                                  <div className="d-flex">
                                    <Form.Item
                                      className="custom-work"
                                      {...restField}
                                      label="Product Group"
                                      labelCol={{
                                        span: window.width > 1024 ? 4 : 6,
                                      }}
                                      name={[name, "assetTitleId"]}
                                      rules={[
                                        {
                                          required: true,
                                          message:
                                            "Product group needs to be selected",
                                        },
                                      ]}
                                    >
                                      <Select
                                        name={[name, "assetTitleId"]}
                                        dropdownRender={(menu) => (
                                          <>
                                            {menu}
                                            <Divider style={{ margin: "8px 0" }} />
                                            <Space style={{ width : "100%", padding: "0 8px 4px" }}>
                                              <Input
                                                placeholder="Please enter item"
                                                ref={inputRef}
                                                value={newProductGroup}
                                                onChange={onProductGroupChange}
                                                maxLength={40}
                                                showCount={{
                                                  formatter: ({ count }) => `${count}/40`,
                                                }}
                                              />
                                              <Button
                                                type="text"
                                                icon={<PlusOutlined />}
                                                onClick={() => {
                                                    if (!newProductGroup?.trim()) {
                                                      toast.error("Product cannot be empty");
                                                      return;
                                                    }
                                                    if (newProductGroup) {
                                                      addProductsGroup(newProductGroup?.trim());
                                                    }
                                                  }
                                                }
                                              >
                                                Add product group
                                              </Button>
                                            </Space>
                                          </>
                                        )}
                                      >

                                        {productsGroupList?.map((item) => (
                                          <Select.Option
                                            value={item?.id}
                                            key={item?.id}
                                          >
                                            <div className="why-work-options">
                                              <div
                                                className="why-work-options-title"
                                                title={item?.title || ""}
                                              >
                                                {item?.title || ""}
                                              </div>
                                              <div
                                                className="why-work-option-delete-btn"
                                                title="Delete item"
                                              >
                                                <Popconfirm
                                                  title="Are you sure?"
                                                  onConfirm={(e) => {
                                                    e.stopPropagation();
                                                    const currentTitle =
                                                      form.getFieldValue([
                                                        whichTab,
                                                        i,
                                                        "assetTitleId",
                                                      ]);
                                                    if (
                                                      currentTitle === item?.title
                                                    ) {
                                                      form.setFieldValue([whichTab, i, "assetTitleId"], "");
                                                      setFormChanged(true);
                                                    }
                                                    deleteProductsGroup(item?.id);
                                                  }}
                                                  okText="Yes"
                                                  cancelText="No"
                                                  zIndex={999999}
                                                >
                                                  <DeleteOutlined
                                                    onClick={(e) => {
                                                      e.preventDefault();
                                                      e.stopPropagation();
                                                    }}
                                                  />
                                                </Popconfirm>
                                              </div>
                                            </div>
                                          </Select.Option>
                                        ))}
                                      </Select>
                                    </Form.Item>

                                    <Form.Item>
                                      <div className="remove-btn">
                                        <DeleteOutlined
                                          title="Delete News"
                                          onClick={() => {
                                            const id = form.getFieldValue([
                                              whichTab,
                                              i,
                                              "id",
                                            ]);
                                            if (id) {
                                              deleteSingleItem(
                                                whichTab,
                                                id,
                                                form
                                              );
                                            } else {
                                              remove(name);
                                              setHasUnsavedItem(false);
                                              refreshUnsavedState();
                                              const currentList =
                                                form.getFieldValue(whichTab) ||
                                                [];
                                              if (currentList.length <= 1) {
                                                setShowClear(false);
                                                setClearEnabled(false);
                                              }
                                            }
                                          }}
                                        />
                                      </div>
                                    </Form.Item>
                                  </div>

                                  <Form.Item
                                    {...restField}
                                    label="Product"
                                    labelCol={{
                                      span: window.width > 1024 ? 4 : 6,
                                    }}
                                    name={[name, "subTitle"]}
                                    rules={[
                                      {
                                        required: true,
                                        message: "Product is required",
                                      },
                                    ]}
                                  >
                                    <Input
                                      placeholder="Enter Sub product"
                                      maxLength={40}
                                      showCount={{
                                        formatter: ({ count }) => `${count}/40`,
                                      }}
                                      onChange={() => {
                                        setShowClear(true);
                                        setClearEnabled(true);
                                      }}
                                      onKeyDown={(e) => {
                                        const currentValue =
                                          form.getFieldValue([whichTab, name, "subTitle"]) || "";

                                        if (
                                          e.key.length === 1 && // normal characters only
                                          currentValue.length >= 40
                                        ) {
                                          form.setFields([
                                            {
                                              name: [whichTab, name, "subTitle"],
                                              errors: ["Title cannot exceed 40 characters"],
                                            },
                                          ]);
                                        }
                                      }}
                                      onBlur={() => {
                                        form.setFields([
                                          {
                                            name: [whichTab, name, "subTitle"],
                                            errors: [],
                                          },
                                        ]);
                                      }}
                                    />
                                  </Form.Item>
                                  <Form.Item
                                    label="Description"
                                    {...restField}
                                    labelCol={{
                                      span: window.width > 1024 ? 4 : 6,
                                    }}
                                    name={[name, "description"]}
                                    rules={[
                                      {
                                        required: true,
                                        message: "Description is required",
                                      },
                                      {
                                        max: MAX_CHARACTERS,
                                        message: `Description should be less than ${MAX_CHARACTERS} characters`,
                                      },
                                    ]}
                                  >
                                    <TextArea
                                      placeholder="Enter Description"
                                      rows={5}
                                      maxLength={MAX_CHARACTERS}
                                      showCount
                                      onChange={() => {
                                        setShowClear(true);
                                        setClearEnabled(true);
                                      }}
                                    />
                                  </Form.Item>
                                  <div className="d-flex">
                                    <Form.Item
                                      {...restField}
                                      className="w-100"
                                      name={[name, "mediaLink", "mediaType"]}
                                      label="Video or Image"
                                      labelCol={{
                                        span: window.width > 1024 ? 4 : 6,
                                      }}
                                    >
                                      <Select
                                        onChange={(e) => {
                                          setShowClear(true);
                                          setClearEnabled(true);
                                          form.setFieldValue(
                                            [whichTab, i, "mediaLink", "url"],
                                            ""
                                          );
                                          form.setFieldValue(
                                            [whichTab, i, "blob"],
                                            undefined
                                          );
                                          if (e === "GIF") {
                                            form.setFieldValue(
                                              [whichTab, i, "mediaLink", "gifCreator"],
                                              createEmptyGifState()
                                            );
                                          } else {
                                            form.setFieldValue(
                                              [whichTab, i, "mediaLink", "gifCreator"],
                                              undefined
                                            );
                                          }
                                        }}
                                        placeholder="Select Option"
                                      >
                                        <Select.Option value="VIMEO_MEDIA">
                                          Add Vimeo Link
                                        </Select.Option>
                                        <Select.Option value="SOCIAL_MEDIA">
                                          Add Youtube Link
                                        </Select.Option>
                                        <Select.Option value="SYNTHESIA_MEDIA">
                                          Add Synthesia Link
                                        </Select.Option>
                                        <Select.Option value="IMAGE">
                                          Upload Image
                                        </Select.Option>
                                        <Select.Option value="GIF">
                                          Create GIF
                                        </Select.Option>
                                      </Select>
                                    </Form.Item>
                                    <Form.Item>
                                      <div className="remove-btn">
                                        <Tooltip title="Upload Video link or image with size lesser than 2.5MB. For best results, use images and videos with a 16:9 aspect ratio">
                                          <QuestionCircleOutlined />
                                        </Tooltip>
                                      </div>
                                    </Form.Item>
                                  </div>
                                  {findValue(i, "type") === "SOCIAL_MEDIA" && (
                                    <Form.Item
                                      label="Youtube Link"
                                      {...restField}
                                      labelCol={{
                                        span: window.width > 1024 ? 4 : 6,
                                      }}
                                      name={[name, "mediaLink", "url"]}
                                    >
                                      <Input
                                        onChange={() => {
                                          setShowClear(true);
                                          setClearEnabled(true);
                                        }}
                                      />
                                    </Form.Item>
                                  )}

                                  {findValue(i, "type") === "VIMEO_MEDIA" && (
                                    <Form.Item
                                      label="Vimeo Link"
                                      {...restField}
                                      labelCol={{
                                        span: window.width > 1024 ? 4 : 6,
                                      }}
                                      name={[name, "mediaLink", "url"]}
                                    >
                                      <Input
                                        onChange={() => {
                                          setShowClear(true);
                                          setClearEnabled(true);
                                        }}
                                      />
                                    </Form.Item>
                                  )}

                                  {findValue(i, "type") === "IMAGE" && (
                                    <Form.Item
                                      {...restField}
                                      label="Image"
                                      colon={false}
                                      name="media"
                                      className="experienceImg"
                                      labelCol={{
                                        span: window.width > 1024 ? 4 : 6,
                                      }}
                                    >
                                      {/* ✅ Show preview if blob or URL exists */}
                                      {findValue(i, "blob") ? (
                                        <Avatar
                                          src={URL.createObjectURL(
                                            findValue(i, "blob")
                                          )}
                                          alt=""
                                        />
                                      ) : findValue(i, "url") ? (
                                        <Avatar
                                          src={findValue(i, "url")}
                                          alt=""
                                        />
                                      ) : (
                                        <Avatar src={UserIcon} />
                                      )}

                                      {/* ✅ File upload button */}
                                      <label className="fileUploadBtn greenBtn">
                                        Upload Image
                                        <input
                                          accept="image/png, image/gif, image/jpeg"
                                          type="file"
                                          onChange={(e) => {
                                            updateImage(e, i, form, whichTab);
                                            setShowClear(true);
                                            setClearEnabled(true);
                                          }}
                                        />
                                      </label>
                                      <Tooltip
                                        className="question"
                                        title={"Recommended image dimensions: 1280x720 pixels"}
                                      >
                                        <QuestionCircleOutlined />
                                      </Tooltip>
                                    </Form.Item>
                                  )}
                                  {findValue(i, "type") === "GIF" && (
                                    <Form.Item
                                      {...restField}
                                      label="Create GIF"
                                      colon={false}
                                      name={[name, "mediaLink", "gifCreator"]}
                                      className="gif-creator-field"
                                      labelCol={{
                                        span: window.width > 1024 ? 4 : 6,
                                      }}
                                      initialValue={createEmptyGifState()}
                                    >
                                      <GifCreator />
                                    </Form.Item>
                                  )}
                                  {findValue(i, "type") ===
                                    "SYNTHESIA_MEDIA" ? (
                                    <Form.Item
                                      label="Synthesia Link"
                                      labelCol={{ span: 6 }}
                                      {...restField}
                                      name={[name, "mediaLink", "url"]}

                                    >
                                      <Input />
                                    </Form.Item>
                                  ) : null}

                                  <Form.Item
                                    label="External Link"
                                    {...restField}
                                    className="w-100"
                                    name={[name, "urlLink"]}
                                    labelCol={{
                                      span: window.width > 1024 ? 4 : 6,
                                    }}
                                  >
                                    <Input
                                      placeholder="External Link"
                                      onChange={() => {
                                        setShowClear(true);
                                        setClearEnabled(true);
                                      }}
                                    />
                                  </Form.Item>

                                  <Form.Item
                                    {...restField}
                                    label="Brochure"
                                    name={[name, "BrochureFile"]}
                                    className="experienceImg w-100"
                                    labelCol={{
                                      span: window.width > 1024 ? 4 : 6,
                                    }}
                                  >
                                    {form.getFieldValue(whichTab)?.[i]
                                      ?.BrochureFile ? (
                                      truncateFilename(
                                        form.getFieldValue(whichTab)[i]
                                          ?.BrochureFile?.name
                                      )
                                    ) : form.getFieldValue(whichTab)?.[i]
                                      ?.brochureFileName ? (
                                      <>
                                        <a
                                          href={
                                            form.getFieldValue(whichTab)[i]
                                              .brochureFilePath || "#"
                                          }
                                        >
                                          <Button
                                            type="button"
                                            icon={<DownloadOutlined />}
                                          >
                                            {truncateFilename(
                                              form.getFieldValue(whichTab)[i]
                                                ?.brochureFileName
                                            )}
                                          </Button>
                                        </a>
                                        <Button
                                          icon={<DeleteOutlined />}
                                          onClick={() =>
                                            form.getFieldValue(whichTab)[i]
                                              .id &&
                                            handleDeleteBrochure(
                                              form.getFieldValue(whichTab)[i].id
                                            )
                                          }
                                        />
                                      </>
                                    ) : (
                                      "No file chosen"
                                    )}
                                    <label
                                      className="fileUploadBtn greenBtn"
                                      style={{ position: "relative" }}
                                    >
                                      {form.getFieldValue(whichTab)?.[i]
                                        ?.brochureFileName
                                        ? "Upload New Brochure"
                                        : "Upload Brochure"}
                                      {/* <input
                                        type="file"
                                        accept="application/pdf"
                                        onChange={(e) => {
                                          updateFile(e, i, form, whichTab);
                                          setShowClear(true);
                                          setClearEnabled(true);
                                          setFormChanged(true);
                                        }}
                                      /> */}
                                      <input
                                        type="file"
                                        accept="application/pdf"
                                        onChange={(e) => {
                                          const file = e.target.files[0];

                                          if (!file) return; // no file selected

                                          // ✅ Check file type (MIME type + extension)
                                          const isPdf =
                                            file.type === "application/pdf" ||
                                            (file.name &&
                                              file.name
                                                .toLowerCase()
                                                .endsWith(".pdf"));

                                          if (!isPdf) {
                                            toast.error(
                                              "Only PDF files are allowed."
                                            );
                                            e.target.value = null; // clear invalid file
                                            return;
                                          }

                                          // ✅ Check file size (optional, e.g., 5MB max)
                                          const maxSize = 5 * 1024 * 1024; // 5 MB
                                          if (file.size > maxSize) {
                                            toast.error(
                                              "File size must be less than 5MB."
                                            );
                                            e.target.value = null;
                                            return;
                                          }

                                          // ✅ If valid, continue existing logic
                                          updateFile(e, i, form, whichTab);
                                          setShowClear(true);
                                          setClearEnabled(true);
                                          setFormChanged(true);
                                        }}
                                      />

                                      <div
                                        className="remove-btn"
                                        style={{
                                          left: "initial",
                                          right: "-30px",
                                        }}
                                      >
                                        <Tooltip title="Only PDF files are allowed. Please upload a PDF not larger than 5MB.">
                                          <QuestionCircleOutlined />
                                        </Tooltip>
                                      </div>
                                    </label>
                                  </Form.Item>

                                  {/* ✅ Save Button */}
                                  <Form.Item
                                    style={{
                                      display: "flex",
                                      justifyContent: "end",
                                    }}
                                  >
                                    {formChanged ? (
                                      <Button
                                        className="saveBtn greenBtn"
                                        onClick={() => {
                                          form.submit();
                                        }}
                                      >
                                        Save
                                      </Button>
                                    ) : (
                                      <Button
                                        className="saveBtn greenBtn"
                                        style={{
                                          opacity: 0.5,
                                          pointerEvents: "none",
                                        }}
                                      >
                                        Save
                                      </Button>
                                    )}
                                  </Form.Item>
                                </Col>
                                <Col
                                  className="gutter-row tabContent"
                                  xs={24}
                                  sm={24}
                                  md={10}
                                  lg={10}
                                >
                                  <Form.Item shouldUpdate noStyle>
                                    {() => {
                                      const row = form.getFieldValue(whichTab)?.[i];
                                      if (!row) return null;
                                      return (
                                        <div>
                                          {renderMedia(row, i)}
                                        </div>
                                      );
                                    }}
                                  </Form.Item>
                                </Col>
                              </div>
                          )}
                        }
                        />
                        </>
                      );
                    }}
                  </Form.List>

                </>
              </Col>

            </>
          ) : (
            <></>
          )
          }
        </Row >
      </div >
    );
  }
}
